import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { INoahDeviceInventoryItemMap, INoahDeviceInventoryItemMapsWithUsagesQueryParams, IQueryResult } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<INoahDeviceInventoryItemMap>, INoahDeviceInventoryItemMapsWithUsagesQueryParams>>(
	undefined as any
);
